import { nextTick } from 'vue'
import type { Ref } from 'vue'
import {
  scheduleScrollChatLogToBottom,
  scrollChatLogToBottom,
} from '@/modules/chat-matrix-fast/utils/scrollToChatMessage'

/** Скролл ленты к низу: стор не должен знать про DOM. */
export function useChatLogScroll(scrollContainerRef: Ref<HTMLElement | null>) {
  const getElement = (): HTMLElement | null => scrollContainerRef.value

  const scrollToBottom = (): void => {
    scheduleScrollChatLogToBottom(getElement())
  }

  const scrollToBottomOnOpen = async (): Promise<void> => {
    await nextTick()
    const apply = () => scrollChatLogToBottom(getElement())
    apply()

    await new Promise<void>(resolve => {
      requestAnimationFrame(() => {
        apply()
        requestAnimationFrame(() => {
          apply()
          resolve()
        })
      })
    })
  }

  return {
    scrollToBottom,
    scrollToBottomOnOpen,
  }
}
